module.exports = {
  alert: ($stateParams, Api) ->
    Api.MonitoringSubjectAlerts.get(id: $stateParams.alertId, subject: $stateParams.subjectId).$promise

  loadTemplates: ($templateCache) ->
    $templateCache.put("alert-navigator", require("./alert-navigator.html"))
}
